// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { connect } from "react-redux";
import { themr } from "react-css-themr";
// import { Switch, Route } from 'react-router-dom';
import { withRouter } from "react-router";
import { format } from "date-fns";

import {
  sideMenu,
  // privileges
} from "@lifepay/rc-ui-toolkit";
import profileSVG from "@lifepay/assets/sprites/icomoon/profile.svg";

// ABSOLUTE PATH IMPORTS
// importing object with action creator functions
// import actions from "model/actions";

import queryFactory, { client } from "model/gql/queries";

// import mutationFactory, { blockCard } from "model/gql/mutations";

// RELATIVE PATH IMPORTS
// importing default component styles
import styles from "./Client.m.scss";

const ClientData = queryFactory(client);

@withRouter
@connect(
  // mapStateToProps function - passes data from store's state.
  (state) => {
    return {};
  },
  // mapDispatchToProps object - pass individual action creators here
  {}
)
@themr("transactions", styles)
export default class Client extends Component {
  static propTypes = {
    theme: PropTypes.object,
    currentClient: PropTypes.object,
  };

  static defaultProps = {
    initialFilters: {},
  };

  render() {
    const { theme, currentClient } = this.props;
    return (
      <div className={classnames(theme.wrapper)}>
        {currentClient ? (
          <ClientData
            skip={!currentClient}
            id={currentClient.remoteId}
            type={currentClient.type}
          >
            {({ data, loaded }) => {
              switch (currentClient.type) {
                case "PERSON": {
                  return data && data.clients && data.clients[0] ? (
                    <sideMenu.Info
                      header={"Информация о клиенте"}
                      summary={{
                        icon: profileSVG,
                        text: data.clients[0].clientName
                          ? data.clients[0].clientName.substring(0, 2)
                          : null,
                      }}
                      showcase={{
                        icon: profileSVG,
                        text: data.clients[0].clientName,
                      }}
                      data={data.clients[0]}
                      sections={[
                        [
                          {
                            key: "birthDate",
                            label: "Дата рождения",
                            formatter: (value) => format(value, "DD.MM.YYYY"),
                          },
                          {
                            key: "passWord",
                            label: "Кодовое слово",
                          },
                          {
                            key: "phone",
                            label: "Мобильный",
                          },
                        ],
                        [
                          {
                            key: "passportSer",
                            label: "Серия и номер паспорта",
                            formatter: (passportSer, data) =>
                              `${passportSer} ${data.passportNum}`,
                          },
                          { key: "passportPlace", label: "Кем выдан" },
                          {
                            key: "passportDate",
                            label: "Дата выдачи",
                            formatter: (value) => format(value, "DD.MM.YYYY"),
                          },
                          {
                            key: "passportCode",
                            label: "Код подразделения",
                          },
                        ],
                      ]}
                    >
                      {/* <privileges.Control /> */}
                    </sideMenu.Info>
                  ) : null;
                }
                case "COMPANY": {
                  return data && data.companies && data.companies[0] ? (
                    <sideMenu.Info
                      header={"Информация о клиенте"}
                      summary={{
                        icon: profileSVG,
                        text: data.companies[0].companyName
                          ? data.companies[0].companyName.substring(0, 2)
                          : null,
                      }}
                      showcase={{
                        icon: profileSVG,
                        text: data.companies[0].companyName,
                      }}
                      data={data.companies[0]}
                      sections={[
                        [
                          {
                            key: "companyFullName",
                            label: "Полное наименование",
                          },
                          {
                            key: "inn",
                            label: "ИНН",
                          },
                        ],
                      ]}
                    />
                  ) : null;
                }
                default: {
                  return null;
                }
              }
            }}
          </ClientData>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/side-menu/Client/Client.js